import {
  EVENT_NAME,
  trackAnalyticsEvent,
  SCREEN_NAMES,
  PRODUCT_AREA,
  SUB_PRODUCT_AREA,
  usePageViewAnalytics,
} from '@leagueplatform/analytics';
import * as React from 'react';
import { LegacyOrderNewCardAnalyticsData } from '#types/analytics.types.ts';
import { BENEFIT_SCREEN_NAMES } from '../constants/analytics-benefit-property-names';

type EventProps = Parameters<typeof trackAnalyticsEvent>[1];

export const useWalletDetailAnalytics = (
  partialParams?: EventProps,
  analyticsData: LegacyOrderNewCardAnalyticsData = {
    benefitId: '',
    vendorId: '',
    benefitName: '',
    benefitSource: '',
    productType: '',
  },
) => {
  const benefitData = React.useMemo(
    () => ({
      product_area: PRODUCT_AREA.WALLET,
      sub_product_area: SUB_PRODUCT_AREA.WALLET,
      screen_name: SCREEN_NAMES.BENEFIT_PAGE,
      benefit_id: analyticsData.benefitId,
      benefit_name: analyticsData.benefitName,
      benefit_product_type: analyticsData.productType,
      benefit_source: analyticsData.benefitSource,
      vendor_id: analyticsData.vendorId,
    }),
    [analyticsData],
  );

  return (eventName: EVENT_NAME, props?: {}) => {
    trackAnalyticsEvent(eventName, {
      ...benefitData,
      ...partialParams,
      ...props,
    });
  };
};

export const useWalletDetailScreenLoaded = (
  screenName: BENEFIT_SCREEN_NAMES,
  analyticsData: LegacyOrderNewCardAnalyticsData = {
    benefitId: '',
    vendorId: '',
    benefitName: '',
    benefitSource: '',
    productType: '',
  },
) => {
  const benefitData = React.useMemo(
    () => ({
      benefit_id: analyticsData.benefitId,
      benefit_name: analyticsData.benefitName,
      benefit_product_type: analyticsData.productType,
      benefit_source: analyticsData.benefitSource,
      product_area: PRODUCT_AREA.WALLET,
      sub_product_area: SUB_PRODUCT_AREA.WALLET,
      screen_name: SCREEN_NAMES.BENEFIT_PAGE,
      vendor_id: analyticsData.vendorId,
    }),
    [analyticsData],
  );

  usePageViewAnalytics({ ...benefitData, screen_name: screenName });
};
